import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26195a3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]

import Avatar from '@/components/images/Avatar.vue';
import useBreakpoints from '@/composables/useBreakpoints';
import { shorten } from '@/lib/utils';
import useWeb3 from '@/services/web3/useWeb3';
import { computed } from 'vue';

import AppNavSettings from './AppNavSettings.vue';

// const { bp, upToLargeBreakpoint } = useBreakpoints();

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// import { computed } from 'vue';

const { upToLargeBreakpoint, isDesktop, bp, isMobile } = useBreakpoints();
const { isLoadingProfile, profile, account } = useWeb3();

const avatarSize = computed(() => {
  if (bp.value === 'sm') {
    return 35;
  } else if (['md', 'lg'].includes(bp.value)) {
    return 40;
  } else {
    return 20;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalPopover = _resolveComponent("BalPopover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isDesktop))
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Wallet"))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_BalPopover, {
        noPad: "",
        align: _unref(isDesktop) ? 'left' : 'left',
        detached: _unref(isDesktop) ? false : true,
        position: _unref(isDesktop) ? 'above' : 'below'
      }, {
        activator: _withCtx(() => [
          _createVNode(_component_BalBtn, {
            class: "text-base",
            loading: _unref(isLoadingProfile),
            loadingLabel: _unref(upToLargeBreakpoint) ? '' : _ctx.$t('connecting'),
            color: "white",
            size: _unref(upToLargeBreakpoint) ? 'md' : 'sm',
            circle: _unref(upToLargeBreakpoint),
            center: false,
            style: { background: 'transparent' }
          }, {
            default: _withCtx(() => [
              (_unref(isMobile))
                ? (_openBlock(), _createBlock(Avatar, {
                    key: 0,
                    iconURI: _unref(profile)?.avatar || '',
                    address: _unref(account),
                    size: _unref(avatarSize)
                  }, null, 8, ["iconURI", "address", "size"]))
                : _createCommentVNode("", true),
              (_unref(profile) && _unref(profile).ens)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    class: "hidden lg:inline-block pl-2",
                    textContent: _toDisplayString(_unref(profile) && _unref(profile).ens)
                  }, null, 8, _hoisted_2))
                : (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    class: "hidden lg:inline-block pl-2 eth-address",
                    textContent: _toDisplayString(_unref(shorten)(_unref(account)))
                  }, null, 8, _hoisted_3))
            ]),
            _: 1
          }, 8, ["loading", "loadingLabel", "size", "circle"])
        ]),
        default: _withCtx(() => [
          _createVNode(AppNavSettings)
        ]),
        _: 1
      }, 8, ["align", "detached", "position"])
    ])
  ], 64))
}
}

})